(() => {
  const setupSticky = (sticky) => {
    if (sticky.dataset.ready) return;
    const form = document.getElementById(sticky.dataset.productFormId);
    const source = form?.querySelector('[name="add"]');
    const button = sticky.querySelector('[data-mereldon-sticky-atc-button]');
    if (!source || !button) return;

    sticky.dataset.ready = 'true';
    const sync = () => {
      button.disabled = source.disabled;
      button.textContent = source.querySelector('span')?.textContent?.trim() || source.textContent.trim();
    };

    sync();
    new MutationObserver(sync).observe(source, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true
    });

    new IntersectionObserver(
      ([entry]) => {
        const show = !entry.isIntersecting && window.scrollY > 160;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
      },
      { threshold: 0.15 }
    ).observe(source);

    button.addEventListener('click', () => source.click());
  };

  const start = () => document.querySelectorAll('[data-mereldon-sticky-atc]').forEach(setupSticky);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();